import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5001`;

const COLORS = {
  panel: '#1e293b',
  border: '#334155',
  text: '#e2e8f0',
  textDim: '#94a3b8',
  accent: '#4ecca3',         // --cenec-green
  accentLight: '#7efcd2',    // --cenec-green-light
  hover: '#1e2a4a',          // --cenec-dark-surface
};

const TariffList = ({ selectedTariffId, onSelect }) => {
  const [countries, setCountries] = useState([]);
  const [utilitiesByCountry, setUtilitiesByCountry] = useState({});
  const [tariffsByUtility, setTariffsByUtility] = useState({});

  // Load countries
  useEffect(() => {
    fetch(`${API}/api/countries`)
      .then((r) => r.json())
      .then((list) => setCountries(list || []))
      .catch(() => {});
  }, []);

  // Load utilities for each country
  useEffect(() => {
    countries.forEach((c) => {
      fetch(`${API}/api/utilities?country=${c.code}`)
        .then((r) => r.json())
        .then((list) => {
          setUtilitiesByCountry((prev) => ({ ...prev, [c.code]: list || [] }));
        })
        .catch(() => {});
    });
  }, [countries]);

  // Load tariffs for each utility (import direction only)
  useEffect(() => {
    Object.entries(utilitiesByCountry).forEach(([countryCode, utilities]) => {
      utilities.forEach((u) => {
        const key = `${countryCode}:${u.id}`;
        fetch(`${API}/api/grid-tariffs?country=${countryCode}&utility_id=${u.id}&direction=import`)
          .then((r) => r.json())
          .then((list) => {
            setTariffsByUtility((prev) => ({ ...prev, [key]: list || [] }));
          })
          .catch(() => {});
      });
    });
  }, [utilitiesByCountry]);

  return (
    <div style={{
      width: '260px',
      minWidth: '260px',
      background: COLORS.panel,
      border: `1px solid ${COLORS.border}`,
      borderRadius: '6px',
      padding: '12px',
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 220px)',
      fontFamily: "'Work Sans', sans-serif",
    }}>
      <div style={{
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: COLORS.textDim,
        marginBottom: '10px',
      }}>
        Import tariffs
      </div>

      {countries.length === 0 && (
        <div style={{ color: COLORS.textDim, fontSize: '13px' }}>No countries yet.</div>
      )}

      {countries.map((country) => {
        const utilities = utilitiesByCountry[country.code] || [];
        return (
          <div key={country.code} style={{ marginBottom: '14px' }}>
            <div style={{
              fontSize: '13px',
              fontWeight: 600,
              color: COLORS.text,
              marginBottom: '6px',
            }}>
              {country.name} ({country.code})
            </div>
            {utilities.map((u) => {
              const key = `${country.code}:${u.id}`;
              const tariffs = tariffsByUtility[key] || [];
              return (
                <div key={u.id} style={{ marginLeft: '8px', marginBottom: '8px' }}>
                  <div style={{
                    fontSize: '12px',
                    color: COLORS.textDim,
                    marginBottom: '4px',
                  }}>
                    {u.name}
                  </div>
                  {tariffs.length === 0 && (
                    <div style={{
                      marginLeft: '8px',
                      fontSize: '12px',
                      color: COLORS.textDim,
                      fontStyle: 'italic',
                    }}>
                      (none)
                    </div>
                  )}
                  {tariffs.map((t) => {
                    const isSelected = t.id === selectedTariffId;
                    return (
                      <button
                        key={t.id}
                        onClick={() => onSelect(t.id)}
                        onMouseEnter={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = COLORS.hover;
                            e.currentTarget.style.color = COLORS.accentLight;
                            e.currentTarget.style.borderLeftColor = COLORS.accent;
                            e.currentTarget.style.paddingLeft = '14px';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = COLORS.textDim;
                            e.currentTarget.style.borderLeftColor = 'transparent';
                            e.currentTarget.style.paddingLeft = '10px';
                          }
                        }}
                        style={{
                          display: 'block',
                          width: '100%',
                          textAlign: 'left',
                          marginLeft: '8px',
                          padding: '6px 10px',
                          marginBottom: '2px',
                          background: isSelected ? COLORS.hover : 'transparent',
                          color: isSelected ? COLORS.accent : COLORS.textDim,
                          fontWeight: isSelected ? 600 : 400,
                          border: 'none',
                          borderLeft: `3px solid ${isSelected ? COLORS.accent : 'transparent'}`,
                          borderRadius: '2px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          fontFamily: 'inherit',
                          transition: 'background 0.15s ease, color 0.15s ease, padding-left 0.15s ease, border-left-color 0.15s ease',
                        }}
                      >
                        {t.name}
                      </button>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default TariffList;
